import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";
import { conditions, ConditionsList } from "../types/ConditionTypeList";

const fetch = (authHeader: string, id?: number) => () =>
  axios.get<ConditionsList<conditions[]>>(`${env.verifyServiceUrl}individual/section_condition/?section__in=${id}`, {
    headers: {
      Authorization: authHeader,
    },
  }).then(response => response.data); // Return only the data part of the response

export const useConditionsList = (id?: number) => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();

  return useQuery(["conditionsList", id], fetch(authHeader, id), {
    retry: false,
    enabled: !!id,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
      if(err.request.status === 401) {
        navigate(ROUTE.LOGOUT);
      }
    }
  });
};



//  const { authHeader } = useAuth();

//   return useMutation((sectionId: number) => {
//     return axios.get(`${env.verifyServiceUrl}individual/section_condition/?section__in=${sectionId}`, {
//       headers: {
//         Authorization: authHeader,
//       },
//     });
//   });
